import { InputHTMLAttributes } from 'react';
import { ChevronDown } from 'lucide-react';
import { Input } from '@/components/ui/input';

type WhatsAppFieldProps = InputHTMLAttributes<HTMLInputElement> & {
  error?: string;
};

export const WhatsAppField = ({ error, ...inputProps }: WhatsAppFieldProps) => (
  <div className="space-y-1.5">
    <label className="text-sm font-semibold text-gray-900">WhatsApp</label>
    <div className="flex overflow-hidden rounded-md border border-input bg-white shadow-xs shadow-input">
      <div className="flex h-10 items-center gap-1 border-r border-input px-3 text-sm text-gray-700">
        +55
        <ChevronDown className="h-3.5 w-3.5 text-gray-500" />
      </div>
      <Input
        {...inputProps}
        className="h-10 border-0 shadow-none focus-visible:ring-0"
        placeholder="Digite o número do whatsapp"
        error={error}
      />
    </div>
    <p className="text-xs text-muted-foreground">
      Opcional. Usado para notificações de novos reports via WhatsApp.
    </p>
  </div>
);
